import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

/** Relative label for legacy display (Figma: "2d ago", "1w ago"). */
export function formatQuestionBankRelativeTime(iso: string | null | undefined): string {
  if (!iso) return 'Never'
  const d = dayjs(iso)
  if (!d.isValid()) return 'Never'
  return d.fromNow(true).replace(/^a /, '1 ').replace(/^an /, '1 ')
}

/** Relative label for detail modal footer (Figma 6074:14180 — "2d Ago"). */
export function formatQuestionBankSavedAgoLabel(iso: string | null | undefined): string {
  if (!iso) return 'Never'
  const d = dayjs(iso)
  if (!d.isValid()) return 'Never'
  const rel = d.fromNow(true).replace(/^a /, '1 ').replace(/^an /, '1 ')
  const short = rel
    .replace(/ minutes?/i, 'm')
    .replace(/ hours?/i, 'h')
    .replace(/ days?/i, 'd')
    .replace(/ weeks?/i, 'w')
    .replace(/ months?/i, 'mo')
    .replace(/ years?/i, 'y')
  return `${short} Ago`
}

/** US-QB-1-23 — "Last used: [date]" on Question Bank cards. */
export function formatQuestionBankLastUsedLabel(iso: string | null | undefined): string {
  if (!iso) return 'Never'
  const d = dayjs(iso)
  if (!d.isValid()) return 'Never'
  return d.format('MMM D, YYYY')
}
